module.exports = __webpack_public_path__ + "img/BN.289ea035.png";